import { Form, useActionData } from "@remix-run/react";
import { PERSON_TITLES, GENDERS, GENDER_IDENTITY } from "~/constants";
import { Field, SelectField } from "../Form";
import {
  FormContainer,
  FormContainerBody,
  FormSection,
  FormContainerFooter,
} from "../Form/Container";
import { FormSectionHeader } from "../Form/FormSectionHeader";
import type { action } from "~/routes/register.personal-info";
import type { PersonalInfo } from "~/types";

export function PersonalInfoForm({
  personalInfo,
}: {
  personalInfo?: PersonalInfo;
}) {
  const actionData = useActionData<typeof action>();
  const errors = actionData?.error;

  return (
    <Form method="POST" replace>
      <FormContainer>
        <FormContainerBody>
          <FormSection>
            <FormSectionHeader title="Personal Information" />

            <div className="grid-cols-2 gap-5 md:grid">
              <Field
                type="text"
                label="First Name *"
                name="first_name"
                error={errors?.fieldErrors?.first_name}
                defaultValue={personalInfo?.first_name}
                placeholder="ex: John"
              />
              <Field
                type="text"
                label="Last Name *"
                name="last_name"
                error={errors?.fieldErrors?.last_name}
                defaultValue={personalInfo?.last_name}
                placeholder="ex: Doe"
              />
              <Field
                type="text"
                label="Preferred first Name"
                name="preferred_first_name"
                defaultValue={personalInfo?.preferred_first_name}
                placeholder="ex: John"
                error={errors?.fieldErrors?.preferred_first_name}
              />
              <SelectField
                label="Title *"
                name="title"
                options={PERSON_TITLES}
                error={errors?.fieldErrors?.title}
                defaultValue={PERSON_TITLES.find(
                  (title) => title.value === personalInfo?.title,
                )}
              />

              <SelectField
                label="Sex *"
                name="sex"
                options={GENDERS}
                error={errors?.fieldErrors?.sex}
                defaultValue={GENDERS.find(
                  (gender) => gender.value === personalInfo?.sex,
                )}
              />

              <SelectField
                label="Gender Identity"
                name="gender_identity"
                options={GENDER_IDENTITY}
                error={errors?.fieldErrors?.gender_identity}
                defaultValue={GENDER_IDENTITY.find(
                  (gender) => gender.value === personalInfo?.gender_identity,
                )}
                info="Gender identity is a person's sense of their gender. It is not necessarily related to physical characteristics, appearance, behaviour, or sexual orientation. Depending on your profession, you may not need to use this field."
              />
              <Field
                type="date"
                label="Date of birth *"
                name="date_of_birth"
                error={errors?.fieldErrors?.date_of_birth}
                defaultValue={personalInfo?.date_of_birth}
                placeholder="Select your birth date"
              />
              <Field
                type="text"
                label="Occupation *"
                name="occupation"
                error={errors?.fieldErrors?.occupation}
                defaultValue={personalInfo?.occupation}
                placeholder="Software Engineer"
              />
            </div>
          </FormSection>

          <FormContainerFooter>
            <button className="btn-primary" type="submit">
              Next
            </button>
          </FormContainerFooter>
        </FormContainerBody>
      </FormContainer>
    </Form>
  );
}
